import React, { Component } from "react";
import $ from "jquery";
import PdfViewer from "./PdfViewer";

class ReportProductionTree extends Component {
    //#region Component Actions
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                Report: "ProductionTree",
                ItemCodeStart: "",
                ItemCodeEnd: "",
                ItemGroup: "",
                Type: "",
            }
        };
    }

    close() {
        $("#ReportProductionTree").modal("hide");
    }

    updateField = (field, value) => {
        let filters = Object.assign({}, this.state.filters);
        filters[field] = value;
        this.setState({ filters });
    }

    validateFilters = () => {
        const { filters } = this.state;
        const { showAlert, GenerateReport } = this.props;

        if ((filters.ItemCodeStart && !filters.ItemCodeEnd) || (!filters.ItemCodeStart && filters.ItemCodeEnd)) {
            return showAlert({ type: "warning", message: "Ingresa un rango de artículos valido" });
        }

        GenerateReport(filters);
    }
    //#endregion

    render() {
        const {
            ListItmsGrpCod,

            // Standard Props
            ListReports,
            ShowPDFViewerModal,
            ShowPDFViewer,
            ReportsModel,
            MailTools,
            printhide,
            ShowFormatToPrint,
        } = this.props;
        const {
            filters
        } = this.state;

        return (
            <div className="no-select">
                <div id="ReportProductionTree" className="modal fade bd-example-modal-lg">
                    <div className="modal-dialog modal-dialog-centered modal-md" role="document" >
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{backgroundColor:"#343a40",borderRadius:"0"}}>
                                <h4 className="modal-title" id="modal-basic-title "> Informe de Lista de Materiales </h4>
                                <button type="button" className="close" onClick={this.close} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="row mt-3">
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="txtBusinessPartner"> Artículos </label>
                                        </div>
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="txtBusinessPartner"> Desde </label>
                                        </div>
                                        <input
                                            id="txtItemCodeStart"
                                            className="form-control"
                                            type="text"
                                            autoComplete="off"
                                            value={filters.ItemCodeStart}
                                            onChange={({target: { value }}) => this.updateField("ItemCodeStart", value)} />
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="txtBusinessPartner"> Hasta </label>
                                        </div>
                                        <input
                                            id="txtItemCodeEnd"
                                            className="form-control"
                                            type="text"
                                            autoComplete="off"
                                            value={filters.ItemCodeEnd}
                                            onChange={({target: { value }}) => this.updateField("ItemCodeEnd", value)} />
                                    </div>
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="slcItemGroup"> Linea </label>
                                        </div>
                                        <select
                                            id="slcItemGroup"
                                            className="form-control"
                                            value={filters.ItemGroup}
                                            onChange={({target: { value }}) => this.updateField("ItemGroup", value)} >
                                            <option value=""> Seleccionar </option>
                                            {ListItmsGrpCod.map(list => <option value={list.ItmsGrpCod}>{list.ItmsGrpNam}</option> )}
                                        </select>
                                    </div>
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="slcType"> Tipo </label>
                                        </div>
                                        <select
                                            id="slcType"
                                            className="form-control"
                                            value={filters.Type}
                                            onChange={({target: { value }}) => this.updateField("Type", value)} >
                                            <option value=""> Todos </option>
                                            <option value="A"> Conjunto </option>
                                            <option value="P"> Producción </option>
                                            <option value="S"> Ventas </option>
                                            <option value="T"> Modelo </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.close}>Cerrar</button>
                            <button type="button" className="btn btn-primary" onClick={this.validateFilters}>Generar</button>
                            </div>
                        </div>
                    </div>
                </div>

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        TypeDoc={"ProductionTreeReport"}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={"SalesTools.EditableDocModel"}
                        RefreshDocModel={"SalesTools.RefreshDocModel"}
                        SaveChanges={"SalesTools.SaveChangesOrderInvoice"}
                        UploadDoc={"SalesTools.UploadInvoice"}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={"user"}
                        Counter={true}
                        MailTools={MailTools}
                        ReportsModel={ReportsModel}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false} />
                }
            </div>
        );
    }
}

export default ReportProductionTree;